// extracted by mini-css-extract-plugin
module.exports = {"splashOverlay":"style_splashOverlay__1CeUg","visible":"style_visible__OP6Aj","hidden":"style_hidden__31Fsd"};